export default function PrivacyPolicy() {
  return (
    <div className="container">
      <h1>Privacy Policy</h1>
      <p>
        We respect your privacy and do not share your personal information with
        third parties.
      </p>
    </div>
  );
}
